
import { CartSheet } from "./CartSheet";
import { ThemeToggle } from "./ThemeToggle";
import { MobileNav } from "./MobileNav";
import { SearchCommand } from "./SearchCommand";
import { FilterMenu } from "./search/FilterMenu";
import { SortMenu } from "./search/SortMenu";
import { SortOption } from "./search/searchUtils";
import { useState } from "react";

interface HeaderProps {
  showSearchInHeader?: boolean;
  selectedCategory: string | null;
  setSelectedCategory: (category: string | null) => void;
  sortBy: SortOption;
  setSortBy: (option: SortOption) => void;
  filterMenuOpen: boolean;
  setFilterMenuOpen: (open: boolean) => void;
  sortMenuOpen: boolean;
  setSortMenuOpen: (open: boolean) => void;
}

export function Header({
  showSearchInHeader = false,
  selectedCategory,
  setSelectedCategory,
  sortBy,
  setSortBy,
  filterMenuOpen,
  setFilterMenuOpen,
  sortMenuOpen,
  setSortMenuOpen
}: HeaderProps) {
  return (
    <div className="sticky top-0 bg-background/95 backdrop-blur-md z-40">
      <div className="container mx-auto px-4">
        <div className={`flex items-center justify-between ${showSearchInHeader ? 'py-2' : 'py-3'} transition-all duration-300`}>
          <div className="flex items-center gap-4">
            <a href="/" className="text-xl font-semibold">
              PharmaCare
            </a>
          </div>
          
          {showSearchInHeader && (
            <div className="flex-1 mx-4 max-w-[500px] hidden md:block">
              <SearchCommand 
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                sortBy={sortBy}
                setSortBy={setSortBy}
                filterMenuOpen={filterMenuOpen}
                setFilterMenuOpen={setFilterMenuOpen}
                sortMenuOpen={sortMenuOpen}
                setSortMenuOpen={setSortMenuOpen}
                showInHeader={true}
              />
            </div>
          )}
          
          <div className="flex items-center gap-3">
            <CartSheet />
            <ThemeToggle />
            <MobileNav />
          </div>
        </div>
      </div>
    </div>
  );
}
